// Ported from vlookup-dramatic/app/mentorlookup/live-sites-collage.tsx by scripts/revamp/port-design.js
import React from "react";
import Image from "../../components/image";
import { mentorLookUp } from "../../lib/content";
import { cn } from "../../lib/utils";
const [sid, sim, essec] = mentorLookUp.heroSites;
export function MluLiveSitesCollage() {
    // min-w-0: the swipeable row below scrolls itself, but its 560px of screens
    // still set this grid item's automatic minimum size, which stretched the
    // hero's single mobile column past the viewport and clipped the headline,
    // copy and CTAs in the neighbouring column.
    return (<div className="min-w-0">
      <p className="mb-5 text-center text-[11px] font-bold uppercase tracking-[0.18em] text-muted-foreground">
        Live programmes — click a screen to visit
      </p>

      {/* QA (31 Aug): below lg the three screens render at one consistent card
          size in a swipeable row (nothing squeezed or cropped), each labelled
          so the different client brandings read as intentional. */}
      <ul className="mlu-sites-row flex snap-x snap-mandatory gap-4 overflow-x-auto lg:hidden">
        {mentorLookUp.heroSites.map((site) => (<li key={site.name} className="w-44 shrink-0 snap-start sm:w-52 md:w-56">
            <Tablet site={site}/>
            <p className="mt-2 truncate text-center text-xs font-bold text-brand-navy/60">
              {site.name}
            </p>
          </li>))}
      </ul>

      <div className="relative mx-auto hidden h-[580px] w-full max-w-[580px] lg:block">
        <div aria-hidden className="pointer-events-none absolute inset-0 [background-image:radial-gradient(rgba(26,58,92,0.09)_1px,transparent_1px)] [background-size:18px_18px]"/>
        <div aria-hidden className="pointer-events-none absolute -right-8 top-10 size-56 rounded-full bg-brand-blue/15 blur-3xl"/>
        <div aria-hidden className="pointer-events-none absolute -left-6 bottom-6 size-48 rounded-full bg-brand-blue/15 blur-3xl"/>

        <Tablet site={sid} className="absolute left-[-2%] top-[2%] z-10 w-[47%] -rotate-[8deg]"/>
        <Tablet site={essec} className="absolute right-[-2%] top-[4%] z-10 w-[47%] rotate-[8deg]"/>
        <Tablet site={sim} className="absolute bottom-4 left-[22%] z-30 w-[56%]"/>
      </div>
    </div>);
}
function Tablet({ site, className, }) {
    const blackBezel = "blackBezel" in site && site.blackBezel;
    const contain = "objectContain" in site && site.objectContain;
    return (<a href={site.href} target="_blank" rel="noopener noreferrer" aria-label={`${site.name} — opens in a new tab`} className={cn("group relative block aspect-[3/4] overflow-hidden rounded-[1.25rem] shadow-[0_22px_48px_-16px_rgba(26,58,92,0.5)] transition-all duration-300 lg:rounded-[1.85rem] lg:hover:z-40 lg:hover:scale-[1.04] lg:hover:shadow-[0_30px_60px_-18px_rgba(26,58,92,0.55)]", blackBezel ? "bg-black p-[9px]" : "bg-white", className)}>
      <span className={cn("relative block h-full w-full overflow-hidden bg-white", blackBezel ? "rounded-[0.9rem] lg:rounded-[1.35rem]" : "rounded-[1.25rem] lg:rounded-[1.85rem]")}>
        <Image src={site.img} alt="" fill sizes="(max-width: 1024px) 33vw, 300px" className={cn("transition-transform duration-500 lg:group-hover:scale-[1.03]", contain ? "object-contain object-top" : "object-cover object-top")}/>
      </span>
    </a>);
}
